/**
 * Centralized React Query key factory for the Buildings listing.
 *
 * Key structure (contract §7):
 *   ['buildings-listing', search, scope, normalizedFilters, sort, pageNumber, pageSize]
 *
 * - Multi-select array values are order-normalized (sorted) before hashing.
 * - Scope type/id and sort field/direction are in fixed order.
 * - search is part of the key when present (narrowing changes → new key → page resets).
 * - The feature namespace 'buildings-listing' distinguishes keys from Inspections queries.
 */
import { buildQueryKeySegment, normalizeMultiSelect } from '@hooks/listings';
export const BUILDINGS_QUERY_NAMESPACE = 'buildings-listing';
/** Normalized filter snapshot used as part of the query key. */
function normalizeFilters(filters) {
    return {
        account: normalizeMultiSelect(filters.account),
        tags: normalizeMultiSelect(filters.tags),
        territory: normalizeMultiSelect(filters.territory),
        additionalTerritory: normalizeMultiSelect(filters.additionalTerritory),
        salesPerson: normalizeMultiSelect(filters.salesPerson),
        compliancePlatform: normalizeMultiSelect(filters.compliancePlatform),
        status: filters.status,
        name: filters.name,
        externalId: filters.externalId
    };
}
/**
 * Builds the full React Query key for a buildings listing state.
 */
export function buildingsQueryKey(state) {
    var _a;
    const segment = buildQueryKeySegment(state.scope, normalizeFilters(state.filters), state.sort, state.page.number, state.page.size);
    return [BUILDINGS_QUERY_NAMESPACE, (_a = state.search) !== null && _a !== void 0 ? _a : '', ...segment];
}
export const buildingsKeys = {
    /** Base key — invalidates all buildings listing queries. */
    all: [BUILDINGS_QUERY_NAMESPACE],
    /** Key scoped to a specific normalized state (used by useQuery). */
    listing: (state) => buildingsQueryKey(state)
};
